import config from 'appConfig';
import datetime from 'lib/datetime';

export const isClickAndCollectEnabled = (): boolean => {
  const startDate = config.disableCncStartDate;

  if (!startDate) return true;

  const now = datetime();
  return !now.isAfter(datetime.tz(startDate, config.timezone));
};

export const isResumedClickAndCollectNoticeEnabled = (): boolean => {
  const endDate = config.cncResumedNoticeEndDate;

  if (!endDate) return false;

  const now = datetime();
  return now.isBefore(datetime.tz(endDate, config.timezone));
};
